module.exports = __webpack_public_path__ + "img/vehicle.8d2df976.svg";